module.exports = __webpack_public_path__ + "static/media/gps.04efef11.svg";